import React from 'react'
import AllProducts from '../../components/store/AllProducts'

const Store = () => {
  return (
    <div>
        <AllProducts />
    </div>
  )
}

export default Store